var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"menuSourceModal",attrs:{"id":"menuSourceModal","title":"Wybierz menu źródła zewnętrznego","hide-footer":""}},_vm._l((_vm.externalSources),function(source,index){return _c('b-button',{key:index,staticClass:"source-change-btn",style:({
      'background-color': _vm.getSourceColor(source),
      color: _vm.getButtonTextColor(source),
    }),attrs:{"block":"","size":"lg"},on:{"click":function($event){return _vm.changeExternalSource(source)}}},[_vm._v(" "+_vm._s(source.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }